// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"delete-confirm_deleteIcon__2BXVJ"};